/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : core.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    I18n,
} from '@aws-amplify/core';

import {
    country_code,
    locale_msg,
} from '@/utils/locale/enums';

// Countries
import {
    en_US,
} from '@/utils/locale/locale_en';

import {
    fr_FR,
} from '@/utils/locale/locale_fr';

import {
    es_MX,
} from '@/utils/locale/locale_es';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const locale_dict =
{
    [country_code.en_US]: en_US,
    [country_code.fr_FR]: fr_FR,
    [country_code.es_MX]: es_MX,
};



// --------------------------------------------------------------------------------
//      MODULE CONFIGURATION
// --------------------------------------------------------------------------------

I18n.putVocabularies(locale_dict);
I18n.setLanguage(country_code.en_US);



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    country_code,
    locale_msg
};



// End of file
